var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-line-container" },
    _vm._l(_vm.lineLocations, function (line, index) {
      return _c(
        "div",
        {
          key: index,
          ref: _vm.baseLineKey + index,
          refInFor: true,
          staticClass: "page-line-item",
          style: { top: line + "px", background: _vm.panelBg },
          on: { mousedown: _vm.handleMouseDown },
        },
        [
          _c("span", { staticClass: "top-span" }),
          _c("span", { staticClass: "bottom-span" }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }